// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-say-home {
  background: #fff7fb;
}

.trainer-say-home {
  background: #f2f2fe;
}

.testimonials_container .testimonial-img {
  width: 80px !important;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  object-fit: cover;
  object-position: top;
}
.testimonials_item h2 span {
  color: var(--dPink);
}
.testimonials_item p {
  position: relative;
  font-size: var(--pSize);
  font-weight: 400;
  padding: 20px 50px 0px;
}
.testimonials_container .tst-1 {
  background: rgba(255, 241, 249, 0.6);
  margin-bottom: 25px;
}

.testimonials_container .tst-2 {
  background: rgb(195 197 248 / 20%);
}
.testimonials_item {
  padding: 80px 58px 0 58px;
  position: relative;
}
img.quotation {
  position: absolute;
  left: 20px;
  top: 0px;
  mix-blend-mode: overlay;
  width: 27%;
  text-align: left;
  height: 100%;
  opacity: 0.1;
  width: 28% !important;
}

.testimonials_container .owl-carousel {
  padding-bottom: 30px;
}

@media (max-width: 576px) {
  .testimonials_item {
    padding: 20px 20px;
    position: relative;
  }
  .testimonials_item p {
    padding: 0px 10px 0px;
  }
  .testimonials_item h3 {
    margin-top: 20px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 992px) {
  .testimonials_item {
    padding: 50px 20px 0 20px;
    position: relative;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/home/Testimonial.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF","sourcesContent":[".parent-say-home {\r\n  background: #fff7fb;\r\n}\r\n\r\n.trainer-say-home {\r\n  background: #f2f2fe;\r\n}\r\n\r\n.testimonials_container .testimonial-img {\r\n  width: 80px !important;\r\n  height: 80px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n  margin: 0 auto;\r\n  object-fit: cover;\r\n  object-position: top;\r\n}\r\n.testimonials_item h2 span {\r\n  color: var(--dPink);\r\n}\r\n.testimonials_item p {\r\n  position: relative;\r\n  font-size: var(--pSize);\r\n  font-weight: 400;\r\n  padding: 20px 50px 0px;\r\n}\r\n.testimonials_container .tst-1 {\r\n  background: rgba(255, 241, 249, 0.6);\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.testimonials_container .tst-2 {\r\n  background: rgb(195 197 248 / 20%);\r\n}\r\n.testimonials_item {\r\n  padding: 80px 58px 0 58px;\r\n  position: relative;\r\n}\r\nimg.quotation {\r\n  position: absolute;\r\n  left: 20px;\r\n  top: 0px;\r\n  mix-blend-mode: overlay;\r\n  width: 27%;\r\n  text-align: left;\r\n  height: 100%;\r\n  opacity: 0.1;\r\n  width: 28% !important;\r\n}\r\n\r\n.testimonials_container .owl-carousel {\r\n  padding-bottom: 30px;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .testimonials_item {\r\n    padding: 20px 20px;\r\n    position: relative;\r\n  }\r\n  .testimonials_item p {\r\n    padding: 0px 10px 0px;\r\n  }\r\n  .testimonials_item h3 {\r\n    margin-top: 20px;\r\n  }\r\n}\r\n@media only screen and (min-width: 576px) and (max-width: 992px) {\r\n  .testimonials_item {\r\n    padding: 50px 20px 0 20px;\r\n    position: relative;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
